import React, { useEffect, useState } from 'react';
import { Button, Popover, Pane, majorScale } from 'evergreen-ui';
import PropTypes from 'prop-types';
import { format, parse } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './date-filter.scss';

const DateFilter = ({ defaultValue, onChange, disabled, prefix }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (defaultValue) {
      try {
        const [startStr, endStr] = defaultValue.split(':');
        const parsedStartDate = parse(startStr, 'yyyy-MM-dd', new Date());
        const parsedEndDate = parse(endStr, 'yyyy-MM-dd', new Date());
        setStartDate(parsedStartDate);
        setEndDate(parsedEndDate);
      } catch {
        setStartDate(null);
        setEndDate(null);
      }
    }
  }, []);

  const handleChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if ((!start && !end) && onChange) {
      onChange('all');
    }

    if (start && end && onChange) {
      onChange(`${format(start, 'yyyy-MM-dd')}:${format(end, 'yyyy-MM-dd')}`);
    }
  };

  const handleSetToday = () => handleChange([new Date(), new Date()]);
  const handleClear = () => handleChange([null, null]);

  // Only show active if the filter exists and it is not "All"
  const showActive = () => startDate && endDate;

  return (
    <Popover
      content={(
        <Pane padding={majorScale(1)}>
          <Pane display="flex" alignItems="center" justifyContent="space-between">
            <Button size="small" onClick={handleSetToday}>Set today</Button>
            <Button size="small" onClick={handleClear}>Clear</Button>
          </Pane>
          <DatePicker
            selected={startDate}
            onChange={handleChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            inline />
        </Pane>
      )}>
      <Button
        size="small"
        disabled={disabled}
        appearance={showActive() ? 'primary' : 'default'}>
        {startDate && endDate ? `${prefix}: ${format(startDate, 'yyyy/MM/dd')} and ${format(endDate, 'yyyy/MM/dd')}` : `${prefix}: All`}
      </Button>
    </Popover>
  );
};

DateFilter.propTypes = {
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  prefix: PropTypes.string,
};

DateFilter.defaultProps = {
  defaultValue: null,
  onChange: null,
  disabled: false,
  prefix: null,
};

export default DateFilter;
